import React, { Fragment } from 'react'

import { Typography } from '@mui/material'
import {
  WorkOrderSearchCheckInOut,
  CheckInOut
} from '../../../interfaces/WorkOrder/WorkOrder'
import { utcToLocal } from '../../../utils/dateHelper'

/*
 * Copyright 2022-07-26 por Alfonso Moya Ecomsur Holding S.A ©
 * Detalle: se módifica CheckDescription por cambio a useReducer + Context
 */

interface CheckDescriptionProps {
  workOrderSearchCheckInOut: WorkOrderSearchCheckInOut | undefined
  checkInWorkOrder: CheckInOut | undefined
}

export const CheckDescription: React.FC<CheckDescriptionProps> = ({
  workOrderSearchCheckInOut,
  checkInWorkOrder
}) => {
  const workOrderOutbound = {
    ot: workOrderSearchCheckInOut?.workOrderId,
    tag: checkInWorkOrder?.workOrderTag,
    carrierName: checkInWorkOrder?.carrierName,
    dispatchDate:
      checkInWorkOrder?.dispatchedDate === null
        ? utcToLocal(checkInWorkOrder?.checkInDate!).split('T')[0]
        : utcToLocal(checkInWorkOrder?.dispatchedDate!).split('T')[0],
    startTime: utcToLocal(checkInWorkOrder?.checkInDate!).split('T')[1],
    finishTime:
      checkInWorkOrder?.checkOutDate !== null &&
      utcToLocal(checkInWorkOrder?.checkOutDate!).split('T')[1].split('.')[0]
  }

  return (
    <Fragment>
      <Typography variant='h5'>Detalle de OT {workOrderOutbound.ot}</Typography>
      {workOrderOutbound.tag && (
        <Typography variant='h6'>Tag {workOrderOutbound.tag}</Typography>
      )}
      <Typography variant='h6'>
        Transportista {workOrderOutbound.carrierName}
      </Typography>
      <Typography variant='h6'>
        Fecha Despacho {workOrderOutbound.dispatchDate}
      </Typography>
      <Typography variant='h5' style={{ color: '#199D03' }}>
        Hora de inicio: {workOrderOutbound.startTime}
      </Typography>
      {workOrderOutbound.finishTime && (
        <Typography variant='h5' style={{ color: '#199D03' }}>
          Hora de término: {workOrderOutbound.finishTime}
        </Typography>
      )}
    </Fragment>
  )
}
